import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Person} from '../../../user/model/Person';
import {IdentificationDocument} from '../../../global/util/IdentificationDocument';
import {FormBuilder, Validators} from '@angular/forms';
import {Constant} from '../../../global/util/Constant';
import {StringUtil} from '../../../global/util/StringUtil';
import {PublicService} from '../../../user/service/public.service';
import {ActivatedRoute} from '@angular/router';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import HttpStatusCode from '../../../global/util/HttpStatusCode';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmationCodeComponent} from '../confirmation-code/confirmation-code.component';
import {ApplicationService} from '../../../user/service/application.service';
import {MoreAboutPerson} from '../../../user/model/common/MoreAboutPerson';
import {UnitMeasure} from '../../../global/util/UnitMeasure';
import {NgxImageCompressService} from 'ngx-image-compress';
import {LocalStorage} from '../../../global/util/LocalStorage';

@Component({
  selector: 'app-register-user',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css']
})
export class UserRegisterComponent implements OnInit {
  public loading: any;
  public personForm: any;
  public person = new Person();
  public identificationDocuments: any[] = [];
  public countries: any[] = [];
  public documentFrontSrc: string | ArrayBuffer;
  public documentRearSrc: string | ArrayBuffer;
  public rubricSrc: string | ArrayBuffer;
  public enterpriseCustomLink: any;
  public jobs: any[] = [];

  @ViewChild('rubricPic', {static: false}) rubricPic: ElementRef;
  private previewRubricWidth = '160';
  private hashCode: string;
  public title = 'TITLE.USER-REGISTER';
  private uuid: string;
  private requestedVerCode: boolean;
  private isLogin = false;
  private sizeOfOriginalImage: number;
  private imageCompress: string | ArrayBuffer;

  constructor(public translate: TranslateService,
              private builder: FormBuilder,
              private service: PublicService,
              private route: ActivatedRoute,
              private modalService: NgbModal,
              private applicationService: ApplicationService,
              private publicService: PublicService,
              private imageCompressService: NgxImageCompressService) {
    this.createForm();
    this.getUUID();
  }

  ngOnInit(): void {
    this.loadCountries();
    this.loadDocumentIdentifications();
    this.hashCode = this.route.snapshot.paramMap.get('hashCode');
    this.verifyEnterpriseLink(this.hashCode);
  }

  verificationCode() {
    if (this.personForm.invalid) {
      this.markAsTouchedAllControls();
      return;
    }
    const openModal = this.modalService.open(ConfirmationCodeComponent, {
      backdrop: 'static'
    });
    openModal.componentInstance.value = this.getDocumentType().concat('_').concat(this.person.documentNumber);
    openModal.componentInstance.email = this.person.email;
    openModal.componentInstance.cellPhone = this.person.cellphone;
    openModal.componentInstance.isLogin = false;
    openModal.componentInstance.messageInfo = this.translate.instant('MESSAGE.ENTER-CONFIRMATION-CODE-TO-REGISTER');
    openModal.componentInstance.title = this.translate.instant('LABEL.VERIFICATION-CODE');
    openModal.result.then(confirmation => {
      if (confirmation) {
        this.register();
      }
    });
  }

  register() {
    this.loading = true;
    this.setFinalValuesBefore2Save();
    this.service.save(this.person).subscribe(value => {
      this.loading = false;
      if (value) {
        this.clearValues();
        Dialog.show(InformType.Success, this.translate.instant(this.title), this.translate.instant('MESSAGE.OPERATION-SUCCESSFULLY-TO-SEND-CREDENTIAL-BY-EMAIL') + value.email.concat('.'));
        setTimeout(() => {
          this.setDefaultValue();
        }, 100);
      }
    }, error => {
      this.loading = false;
      if (error.status === HttpStatusCode.FOUND) {
        this.clearValues();
        Dialog.show(InformType.Warning, this.translate.instant(this.title), this.translate.instant('MESSAGE.USER-WAS-REGISTERED'));
        setTimeout(() => {
          this.setDefaultValue();
        }, 100);
      } else {
        Dialog.show(InformType.Danger, this.translate.instant(this.title));
      }
    });
  }

  isInvalidControl(ctrlName: string) {
    return this.personForm.get(ctrlName).invalid && this.personForm.get(ctrlName).touched;
  }

  onChangeDocType() {
    const documentType = this.person.documentType;
    switch (documentType) {
      case IdentificationDocument.DNI:
        this.personForm.get('documentNumber').setValidators(
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[0-9]{8}')])
        );
        break;
      case IdentificationDocument.CE:
        this.personForm.get('documentNumber').setValidators(
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[0-9]{9,11}')])
        );
        break;
      case IdentificationDocument.PAS:
        this.personForm.get('documentNumber').setValidators(
          Validators.compose(
            [
              Validators.required,
              Validators.pattern('^[a-zA-Z0-9]{8,20}')])
        );
        break;
    }
    this.personForm.get('documentNumber').updateValueAndValidity();
  }

  cleanDataAfterChanges() {
// Completar
  }

  getErrorMessageBy(ctrlName: string): string {
    const formControl = this.personForm.get(ctrlName);
    const hasRequiredError = formControl.hasError('required');
    const hasPatternError = formControl.hasError('pattern');
    let actualValue;
    switch (ctrlName) {
      case 'documentNumber':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-THE')
            .concat(this.getDescriptionOfDocumentTypeBy(this.person.documentType))
            .concat(this.translate.instant('MESSAGE.REQUIRED'));
        } else if (hasPatternError) {
          actualValue = formControl.errors.pattern.actualValue ? formControl.errors.pattern.actualValue : '';
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
            .concat(this.getDescriptionOfDocumentTypeBy(this.person.documentType));
        }
        break;
      case 'phoneNumber':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.ENTER-THE')
            .concat(this.translate.instant('MESSAGE.TELEPHONE-NUMBER'))
            .concat(this.translate.instant('MESSAGE.REQUIRED'));
        } else if (hasPatternError) {
          actualValue = formControl.errors.pattern.actualValue;
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
            .concat(this.translate.instant('MESSAGE.TELEPHONE-NUMBER'));
        }
        break;
      case 'email':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.EMAIL-IS-REQUIRED');
        } else if (hasPatternError) {
          actualValue = formControl.errors.pattern.actualValue;
          return '\''
            .concat(String(actualValue))
            .concat(this.translate.instant('MESSAGE.NOT-COMPLY-WITH-REQUIRED'))
            .concat(this.translate.instant('MESSAGE.EMAIL'));
        }
        break;
      case 'firstname':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.NAME-IS-REQUIRED');
        } else if (hasPatternError) {
          actualValue = formControl.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-NAME');
        }
        break;
      case 'lastname':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.FATHERS-LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = formControl.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
      case 'lastname2':
        if (hasRequiredError) {
          return this.translate.instant('MESSAGE.MOTHERS-LAST-NAME-ARE-REQUIRED');
        } else if (hasPatternError) {
          actualValue = formControl.errors.pattern.actualValue;
          return this.translate.instant('MESSAGE.DO-NOT-ENTER-SPACES-AT-BEGINNING-AND-END-OF-THE-LAST-NAMES');
        }
        break;
    }
  }

  public getDescriptionOfDocumentTypeBy(id: number) {
    return this.identificationDocuments.find(documentType => documentType.id === id).shortDescription;
  }

  readSelectedDocumentFront(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.documentFrontSrc = reader.result;
        this.verifyImageSizeAllowed(reader.result, 'documentFrontFileBase64');
      };
      reader.readAsDataURL(file);
    }
  }

  changeStatus3(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.personForm.patchValue({
      documentFrontFileBase64: testFile.base64,
      documentFrontFilename: testFile.name,
      documentFrontFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityObverseDNIFields();
  }

  readSelectedRubric(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.rubricSrc = reader.result;
        this.verifyImageSizeAllowed(reader.result, 'rubricFileBase64');
      };
      reader.readAsDataURL(file);
    }
  }

  readSelectedBackDNI(event: any) {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.documentRearSrc = reader.result;
        this.verifyImageSizeAllowed(reader.result, 'documentRearFileBase64');
      };
      reader.readAsDataURL(file);
    }
  }

  changeStatus4(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.personForm.patchValue({
      documentRearFileBase64: testFile.base64,
      documentRearFilename: testFile.name,
      documentRearFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityBackDNIFields();
  }

  /**
   * Registra y envía el código de verificación para el registro de la persona.
   */
  public sendVerificationCode(): void {
    const url = Constant.ROOT_API_V1 + '/public/send-verification-code';
    const formData = new FormData();
    formData.append('uuid', this.uuid);
    formData.append('value', this.getDocumentType() + '_' + this.person.documentNumber);
    formData.append('email', this.person.email);
    formData.append('isLogin', String(this.isLogin));
    this.loading = true;
    this.applicationService.post(url, formData).subscribe(() => {
      this.loading = false;
      this.requestedVerCode = true;
    }, () => {
      this.loading = false;
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.VERIFICATION-CODE'), this.translate.instant('MESSAGE.ERROR-OCCURRED-TO-SEND-VERIFICATION-CODE'));
    });
  }

  getDocumentType() {
    switch (this.person.documentType) {
      case Constant.DNI:
        return 'dni';
      case Constant.CARNE_EXTRANJERIA:
        return 'ce';
      default:
        return 'pass';
    }
  }

  private getUUID(): void {
    const url = Constant.ROOT_API_V1 + '/public/uuid';
    this.applicationService.get(url).subscribe((value: any) => {
      this.uuid = value.uuid;
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.OBTAINING-UUID'));
    });
  }

  private createForm() {
    this.personForm = this.builder.group({
      documentType: [null, Validators.required],
      documentNumber: [null, Validators.required],
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      lastname2: [null, Validators.required],
      email: [null, Validators.compose([Validators.required,
        Validators.pattern('^([a-zA-Z0-9_\\-\\.]+)@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.)|(([a-zA-Z0-9\\-]+\\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\\]?)$')])],
      phoneNumber: [null],
      rubricFileBase64: ['', Validators.required],
      rubricFilename: ['', Validators.required],
      rubricFilename2Show: ['', Validators.required],
      documentFrontFileBase64: [''],
      documentFrontFilename: [null, Validators.required],
      documentFrontFilename2Show: [null, Validators.required],
      documentRearFilename2Show: [null, Validators.required],
      documentRearFilename: [null, Validators.required],
      documentRearFileBase64: [''],
      country: [null, Validators.required],
      job: [null, Validators.required]
    });
  }

  private loadCountries() {
    this.service.getCountries().subscribe(next => {
      if (next) {
        this.countries = next._embedded.countries;
        this.person.countryId = this.countries[Constant.ZERO_INDEX].id;
      }
    });
  }

  private loadDocumentIdentifications() {
    this.service.getDocumentIdentifications().subscribe(next => {
      if (next) {
        this.identificationDocuments = next._embedded.identificationdocuments;
        this.person.documentType = this.identificationDocuments[Constant.ZERO_INDEX].id;
      }
    });
  }

  changeStatus2(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    this.personForm.patchValue({
      rubricFileBase64: testFile.base64,
      rubricFilename: testFile.name,
      rubricFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
    });
    this.updateValueAndValidityRubricFields();
  }

  private markAsTouchedAllControls() {
    Object.values(this.personForm.controls).forEach(control => {
      // @ts-ignore
      control.markAsTouched();
    });
  }

  private setFinalValuesBefore2Save() {
    this.person.type = Constant.LEGAL_PERSON;
    this.person.roles = Constant.USER_ROLE_ID;
    this.person.scope = Constant.USER;
    this.person.partnerId = this.enterpriseCustomLink.partnerId;
    this.person.enterpriseId = this.getEnterpriseId();
    this.person.enterpriseIdView = this.getEnterpriseId();
    this.person.rubricFilename = this.personForm.get('rubricFilename').value;
    this.person.rubricBase64Data = this.getImageCompress(this.personForm.get('rubricFileBase64').value, 'rubricFileBase64');
    this.person.documentFrontFilename = this.personForm.get('documentFrontFilename').value;
    this.person.documentFrontBase64Data = this.getImageCompress(this.personForm.get('documentFrontFileBase64').value, 'documentFrontFileBase64');
    this.person.documentRearBase64Data = this.getImageCompress(this.personForm.get('documentRearFileBase64').value, 'documentRearFileBase64');
    this.person.documentRearFilename = this.personForm.get('documentRearFilename').value;
    const moreAboutPerson = new MoreAboutPerson();
    moreAboutPerson.haveTwoFactorAuthentication = true;
    this.person.moreAboutPerson = moreAboutPerson;
    this.upperCase2Fields();
  }

  getEnterpriseId() {
    return this.enterpriseCustomLink.enterpriseId;
  }

  verifyEnterpriseLink(hashCode) {
    if (hashCode) {
      this.service.getEnterpriseCustomLink(hashCode).subscribe((customLink: any) => {
        this.enterpriseCustomLink = customLink;
        this.loadJobs(customLink.enterpriseId);
        if (customLink.moreAboutEnterpriseCustomLink) {
          localStorage.setItem('enterpriseLogoBase64', customLink.moreAboutEnterpriseCustomLink.base64LogoFile);
          localStorage.setItem('logoFileExtension', customLink.moreAboutEnterpriseCustomLink.logoFileExtension);
        }
      }, () => {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.REGISTRATION-LINK'), 'La url para el registro de usuarios presenta problemas, contacte con su administrador o intente más tarde.');
      });
    }
  }

  loadJobs(enterpriseId) {
    this.service.getJobs(enterpriseId).subscribe((next: any) => {
      if (next) {
        this.jobs = next._embedded.jobs;
        this.person.jobId = this.jobs[Constant.ZERO_INDEX].id;
      }
    });
  }

  search() {
    this.loading = true;
    const urlSearch = Constant.ROOT_API_V1
      .concat('/public/search/on-reniec/')
      .concat(this.person.documentNumber)
      .concat('/people');
    this.publicService.get(urlSearch).subscribe((person: any) => {
      this.person.documentNumber = person.documentNumber;
      this.person.firstname = person.firstname;
      this.person.lastname = person.lastname;
      this.person.lastname2 = person.lastname2;
      this.loading = false;
    }, error => {
      this.loading = false;
      if (error.status === HttpStatusCode.NOT_FOUND) {
        this.person.fullname = '';
        this.person.firstname = '';
        this.person.lastname = '';
        this.person.lastname2 = '';
        Dialog.show(InformType.Warning, this.translate.instant('TITLE.PERSON'), error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.translate.instant('TITLE.PERSON'));
        return;
      }
    });
  }

  private upperCase2Fields() {
    this.person.firstname = this.person.firstname.toUpperCase();
    this.person.lastname = this.person.lastname.toUpperCase();
    this.person.lastname2 = this.person.lastname2.toUpperCase();
  }

  private updateValueAndValidityRubricFields() {
    this.personForm.get('rubricFileBase64').updateValueAndValidity();
    this.personForm.get('rubricFilename').updateValueAndValidity();
    this.personForm.get('rubricFilename2Show').updateValueAndValidity();
  }

  private updateValueAndValidityObverseDNIFields() {
    this.personForm.get('documentFrontFileBase64').updateValueAndValidity();
    this.personForm.get('documentFrontFilename').updateValueAndValidity();
    this.personForm.get('documentFrontFilename2Show').updateValueAndValidity();
  }

  private updateValueAndValidityBackDNIFields() {
    this.personForm.get('documentRearFileBase64').updateValueAndValidity();
    this.personForm.get('documentRearFilename').updateValueAndValidity();
    this.personForm.get('documentRearFilename2Show').updateValueAndValidity();
  }

  private clearValues() {
    this.personForm.reset();
  }

  setDefaultValue() {
    this.person = new Person();
    this.documentFrontSrc = this.placeHoldItRubric;
    this.documentRearSrc = this.placeHoldItRubric;
    this.rubricSrc = this.placeHoldItRubric;
    this.person.documentType = this.identificationDocuments[Constant.ZERO_INDEX].id;
    this.person.jobId = this.jobs[Constant.ZERO_INDEX].id;
    this.person.countryId = this.countries[Constant.ZERO_INDEX].id;
    this.personForm.get('documentType').setValue(this.identificationDocuments[Constant.ZERO_INDEX].id);
    this.personForm.get('job').setValue(this.jobs[Constant.ZERO_INDEX].id);
    this.personForm.get('country').setValue(this.countries[Constant.ZERO_INDEX].id);
  }


  /*Se comprime la imagen reduciendo el tamaño en 40% y se mantiene la calidad en un 40% siempre en cuando supera 1 MB*/
  verifyImageSizeAllowed(imageToCompress: any, name?: string): any {
    this.sizeOfOriginalImage = this.imageCompressService.byteCount(imageToCompress) / (1024 * 1024);
    console.log('Size in bytes is now:', this.sizeOfOriginalImage);
    if (this.sizeOfOriginalImage >= UnitMeasure.ONE_MB && imageToCompress !== '') {
      const orientation = -1;
      this.imageCompressService.compressFile(imageToCompress, orientation, 40, 40).then(result => {
        this.imageCompress = result;
        LocalStorage.setItem(name, result);
      });
    }
  }

  private getImageCompress(imageCompress: string, name?: string) {
    return LocalStorage.getImageCompress(imageCompress, name);
  }

  get styleDimensionsRubric(): string {
    return 'width: ' + this.previewRubricWidth + 'px; height: auto';
  }

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE_PATH_235_150;
  }

  get defaultDocumentFrontSrc(): string | ArrayBuffer {
    return this.documentFrontSrc || this.placeHoldItRubric;
  }

  get defaultDocumentRearSrc(): string | ArrayBuffer {
    return this.documentRearSrc || this.placeHoldItRubric;
  }

  get defaultRubricSrc(): string | ArrayBuffer {
    return this.rubricSrc || this.placeHoldItRubric;
  }
}
